// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26HIS","newExpiryDate":"styles_newExpiryDate__1Ocpo","footer":"styles_footer__1DWt7"};